/**
 * This file carries all the application messages.
 */
export const constant = {
  loginforLOA2Status: 'SUCCESS',
  loginSuccessStatus: 'FACTOR_SELECT',
  loginFailStatus: 'AUTHN_FAILED',
  factorSuccessStatus: 'MFA_CHALLENGE',
  failStatus: 'FAILURE',
  mfaSuccessStatus: 'SUCCESS',
  passwordExpiredStatus: 'PASSWORD_EXPIRED',
  passwordWarningStatus: 'PASSWORD_WARN',
  accountLockStatus: 'LOCKED_OUT',
  mfaEnrolStatus: 'MFA_ENROLL',
  invalidMfaCode: 'INVALID_CODE',
  //mfaEnrolStatus: 'SUCCESS',
  errorTextTest: 'testing success',
  sessionExist: 'SESSION_EXISTS',
  tmpver: 'temp',
  validSession: 'VALID_SESSION',
  systemFailure: 'SYSTEM_FAILURE',
  factorPushStatus: 'SUCCESS',
  factorPushDenialStatus: 'DENIED',
  invalidSession: 'Invalid Session',
  unkownState: 'UNKNOWN_STATE',
  tooManyRequests: 'TOO_MANY_REQUESTS',

  SECURITY_CODE_SUCCESSFULLY_RESENT_ALERT: {
    type: 'success',
    message: 'A new security code was successfully sent.',
  },

  //Error codes from UI and their definitions. The below errorcodes were written  to make the UI user friendly. Most of these errorcodes will be displayed
  // on the UI only when their is api call failure.

  USR_FACT_CHK_CALL_FAILURE_0:
    'An unexpected error occurred while resending two-factor authentication code. Please wait a few minutes and try again. If the issue persists, contact the help desk with the error code: ERRLGNUI01',
  USR_FACT_CHK_CALL_FAILURE_1:
    'An unexpected error occurred while sending two-factor authentication code. Please wait a few minutes and try again. If the issue persists, contact the help desk with the error code: ERRLGNUI02',
  USR_FACT_CHK_CALL_FAILURE_CODE:
    'ERRLGNUI01 && ERRLGNUI02 : userFactorCheck() call failed, please check the logs',

  SEND_CODE_CHK_CALL_FAILURE_0:
    'An unexpected error occurred while verifying two-factor authentication code. Please wait a few minutes and try again. If the issue persists, contact the help desk with the error code: ERRLGNUI03',
  SEND_CODE_CHK_CALL_FAILURE_1:
    'An unexpected error occurred while sending two-factor authentication code. Please wait a few minutes and try again. If the issue persists, contact the help desk with the error code: ERRLGNUI04',
  SEND_CODE__CHK_CALL_FAILURE_CODE:
    'ERRLGNUI03 && ERRLGNUI04: sendCodeCheck() call failed, please check the logs',

  INIT_MFA_RECOV_CHK_CALL_FAILURE_0:
    'An unexpected error has occurred. Please contact your help desk with the errorcode : ERRLGNUI05',
  INIT_MFA_RECOV_CHK_CALL_FAILURE_CODE_0:
    'ERRLGNUI05 : initiateMFARecovery() call failed, call to factor recovery service failed because of expired/invalid session ',

  INIT_MFA_RECOV_CHK_CALL_FAILURE_1:
    'An unexpected error has occurred. Please contact your help desk with the errorcode : ERRLGNUI06',
  INIT_MFA_RECOV_CHK_CALL_FAILURE_CODE_1:
    'Your account is not in the appropriate state and/or may be missing critical data to continue this activity. Please contact your help desk.',

  ON_VRFY_REC_ANS_CALL_FAILURE_0:
    'An unexpected error occurred while verifying  challenge question answer. Please wait a few minutes and try again. If the issue persists, contact the help desk with the error code: ERRLGNUI07',
  ON_VRFY_REC_ANS_CALL_FAILURE_CODE_0:
    'ERRLGNUI07 : onVerifyRecoveryAnswer() @ ChallengeQuestionComponent call failed, please check the logs',

  ON_VRFY_REC_ANS_CALL_FAILURE_1:
    'An unexpected error occurred while verifying  challenge question answer. Please wait a few minutes and try again. If the issue persists, contact the help desk with the error code: ERRLGNUI08',
  ON_VRFY_REC_ANS_CALL_FAILURE_CODE_1:
    'ERRLGNUI08 : onVerifyRecoveryAnswer() @ MfaChallengeComponent  call failed, please check the logs',

  ON_SND_EMAIL_CALL_FAILURE:
    'An unexpected error occurred while recovering account. Please wait a few minutes and try again. If the issue persists, contact the help desk with the error code: ERRLGNUI09',
  ON_SND_EMAIL_CALL_FAILURE_CODE_1:
    'ERRLGNUI09 : onSendEmail()   call failed, please check the logs',

  NG_ONINIT_CALL_FAILURE:
    'An unexpected error occurred while resetting challenge question. Please wait a few minutes and try again. If the issue persists, contact the help desk with the error code: ERRLGNUI10',
  NG_ONINIT_CALL_FAILURE_CODE_1:
    'ERRLGNUI010 : ngOnInit()   call failed, please check the logs',

  ON_SET_RECOV_CALL_FAILURE:
    'An unexpected error occurred while resetting challenge question. Please wait a few minutes and try again. If the issue persists, contact the help desk with the error code: ERRLGNUI11',
  ON_SET_RECOV_CALL_FAILURE_CODE_1:
    'ERRLGNUI011 : onSetRecovery()   call failed, please check the logs',

  ON_SEND_EMAIL_CALL_FAILURE:
    'An unexpected error occurred while sending account recovery email. Please wait a few minutes and try again. If the issue persists, contact the help desk with the error code: ERRLGNUI12',
  ON_SEND_EMAIL_CALL_FAILURE_CODE_1:
    'ERRLGNUI012 : onSendEmail()   call failed, please check the logs',

  TOO_MANY_REQUESTS_ERROR_MSG:
    'A security code was recently sent. Please wait 30 seconds before trying again.',
  FORGOT_PWD_UNSUPPORTED_EUA_USER:
    'This functionality is not currently supported for EUA users in HARP. Please log into EUA to manage your two-factor authentication devices. If you have questions, please contact the help desk with the error code: ERRFRS001',
  OKTA_VERIFY_PUSH_TIMEOUT:
    'The Okta Verify Push notification has expired. You will be redirected back to the login page shortly.',
};
